import type { Tile } from '../../hex/types';

/**
 * Stable integer seed derived from axial coordinates + optional salt.
 * Used to keep per-tile render variation deterministic.
 */
export function tileSeed(tile: Tile, salt = 0): number {
    const { q, r } = tile.position;
    const base = ((q * 73856093) ^ (r * 19349663)) >>> 0;
    return (base ^ salt) >>> 0;
}

/**
 * Convenience overload for seed from axial coordinates only.
 */
export function tileSeedFromPos(q: number, r: number, salt = 0): number {
    const base = ((q * 73856093) ^ (r * 19349663)) >>> 0;
    return (base ^ salt) >>> 0;
}
